{
	"label": "Workspace",
	"open": "Open the sidebar",
	"collapse": "Hide sidebar",
	"expand": "Show sidebar",
	"collapseKey": "Ctrl \\",
	"untitled": "Untitled",
	"items": {
		"search": "Search",
		"searchKey": "Ctrl K",
		"home": "Home",
		"trash": "Trash",
		"activity": "Activity",
		"members": "Members",
		"deployments": "Deployments",
		"notifications": "Notifications"
	},
	"sections": {
		"pages": "Pages",
		"favorites": "Favorites"
	},
	"new": {
		"page": "New page",
		"board": "New board"
	},
	"tree": {
		"loading": "Loading pages…",
		"loadError": "Pages could not load. Try again.",
		"empty": "No pages inside",
		"showMore": "Show more",
		"expand": "Open {{title}}",
		"collapse": "Close {{title}}",
		"addInside": "Add inside {{title}}",
		"addHeading": "Add inside",
		"menu": "More for {{title}}",
		"moved": "Page moved",
		"dnd": {
			"picked": "Picked up {{title}}. Move over another page, then let go.",
			"dropped": "Dropped.",
			"cancelled": "Move cancelled."
		}
	},
	"search": {
		"title": "Search",
		"placeholder": "Search pages…",
		"hint": "Type to search page titles and text.",
		"recent": "Recent",
		"none": "Nothing matches “{{q}}”."
	},
	"notifications": {
		"title": "Notifications",
		"markAll": "Mark all as read",
		"loading": "Loading…",
		"loadError": "Notifications could not load. Try again.",
		"emptyTitle": "You're all caught up",
		"emptyBody": "When someone assigns you to a card or adds you to one, it shows up here.",
		"more": "Show older",
		"new": "Unread",
		"unread_one": "{{count}} unread notification",
		"unread_other": "{{count}} unread notifications",
		"arrived_one": "You have a new notification",
		"arrived_other": "You have {{count}} new notifications",
		"assigned": "{{name}} assigned you to “{{card}}”",
		"person": "{{name}} added you as {{property}} on “{{card}}”",
		"comment": "{{name}} commented on “{{card}}”"
	},
	"theme": {
		"label": "Appearance",
		"light": "Light",
		"dark": "Dark",
		"system": "System",
		"toDark": "Switch to dark mode",
		"toLight": "Switch to light mode"
	},
	"profile": {
		"menu": "Account menu for {{name}}",
		"activeRole": "Active role",
		"switchRole": "Switch role"
	}
}
